import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { scheduleRemovePreloader } from './core/utils';
import store from './core/store';
import App from './App';

declare global {
  interface Window {
    ga: any;
    fbq: any;
    AF: any;
    gtag: any;
    google_tag_manager?: Record<string, unknown>;
    ttq: any;
    uetq?: { push(...args: unknown[]): unknown };
    AF_SMART_SCRIPT: any;
    TiktokJelly: any;
    hj: any;
    ApplePaySession: any;
    google: {
      accounts: {
        id: {
          initialize: (config: {
            client_id: string;
            callback: (response: { credential: string }) => void;
            ux_mode: string;
            auto_select: boolean;
            cancel_on_tap_outside: boolean;
          }) => void;
          prompt: () => void;
          renderButton: (
            element: HTMLElement,
            options: {
              type: 'standard';
              theme: 'outline';
              size: 'large';
              text: 'continue_with';
              shape: 'rectangular';
              logo_alignment: 'left';
              width: string;
            },
          ) => void;
        };
      };
      maps: any;
    };
  }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const persistor = persistStore(store);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor} onBeforeLift={scheduleRemovePreloader}>
      <App />
    </PersistGate>
  </Provider>,
);
